import { getScimBaseUrl, isMfaEnabled, isOrgUiEnabled, isScimPerOrgEnabled, } from '@thoughtspot/session-service';
import { isOktaEnabled } from '@thoughtspot/system-config-service';
import { useUserManagementAuthFlags, useUserManagementOrgContext, } from './user-management-status-context';
export const useAuthSettingsVisibility = () => {
    const auth = useUserManagementAuthFlags();
    const { isAllOrgContext, effectiveOrgId } = useUserManagementOrgContext();
    const orgsUiOn = isOrgUiEnabled();
    const showScim = !!auth.saml &&
        (orgsUiOn
            ? isAllOrgContext || (effectiveOrgId !== 0 && isScimPerOrgEnabled())
            : true) &&
        getScimBaseUrl().length !== 0;
    const showMfa = !!auth.saml &&
        isOktaEnabled() &&
        isMfaEnabled() &&
        (orgsUiOn ? isAllOrgContext : true);
    const showLocalAuth = !!auth.internal_auth;
    return {
        showScim,
        showLocalAuth,
        showMfa,
        showGear: showScim || showLocalAuth || showMfa,
    };
};
//# sourceMappingURL=use-auth-settings-visibility.js.map